//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "box",
  props: {
    ads_conf: undefined
  },
  created() {
    console.log("this ads_conf:", this.ads_conf)
  }
}
